module.exports = __webpack_public_path__ + "img/8.9b7d670e.jpg";